import { MutableRefObject, useRef } from "react";
import { Search } from "react-bootstrap-icons";
import { $SiteColors } from "../../../config/company-atts";

export const InputSearch = () => {
  
  return (
    <form className="header__form">
      <input
        className={$SiteColors.getState().searchFieldStyle}
        id="Myinput"
        style={{ color: $SiteColors.getState().headerTextColor, backgroundColor:$SiteColors.getState().searchField}}
        type="text"
        placeholder="Поиск"
      />
      <button className="input__button" style={{ color: $SiteColors.getState().headerTextColor }}>
        <Search />
      </button>
    </form>
  );
};
